import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FAQSection = () => {
  const [openQuestion, setOpenQuestion] = useState('O que é MEI?');

  const faqs = [
    {
      title: 'O que é MEI?',
      content: (
        <>
          <p>O Microempreendedor Individual (MEI) é o tipo mais simples de empresa e foi criado pelo Governo para permitir que o pequeno empresário tenha fácil acesso a um CNPJ, por um custo baixo e sem burocracia. Ele deve atender as seguintes condições:</p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li>Faturamento limitado a R$ 81.000,00 por ano (receita bruta);</li>
            <li>Não participar como sócio, administrador ou titular de outra empresa;</li>
            <li>Ter no máximo um empregado;</li>
            <li>Exercer uma das atividades econômicas previstas pelo MEI (confira aqui todas as atividades).</li>
          </ul>
          <p className="mt-4">Torne-se MEI agora mesmo e junte-se a mais de 7 milhões de brasileiros que saíram da informalidade e já estão aproveitando de todos os benefícios oferecidos.</p>
        </>
      )
    },
    {
      title: 'Posso ser MEI?',
      content: 'Conteúdo detalhado sobre quem pode se tornar um MEI.'
    },
    {
      title: 'Quem não pode ser MEI?',
      content: 'Informações sobre restrições para se tornar um Microempreendedor Individual.'
    },
    {
      title: 'Quantas Atividades o MEI pode ter? Quais são?',
      content: 'Detalhes sobre o número e tipos de atividades permitidas para MEI.'
    },
    {
      title: 'Como funciona o processo de abertura do MEI?',
      content: 'Passo a passo para abrir seu Microempreendedor Individual.'
    }
  ];

  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2C5E50] mb-12 text-center md:text-left">
          PERGUNTAS FREQUENTES SOBRE A MEUmei
        </h2>

        <div className="space-y-4">
          {faqs.map((faq) => (
            <div key={faq.title} className="border-b">
              <motion.div 
                className="flex justify-between items-center cursor-pointer py-4"
                onClick={() => setOpenQuestion(
                  openQuestion === faq.title ? '' : faq.title
                )}
                whileHover={{ scale: 1.02 }}
              >
                <h3 className="text-base md:text-xl font-semibold text-[#2C5E50]">
                  {faq.title}
                </h3>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </motion.div>
              <AnimatePresence>
                {openQuestion === faq.title && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ 
                      opacity: 1, 
                      height: 'auto',
                      transition: { duration: 0.3 }
                    }}
                    exit={{ 
                      opacity: 0, 
                      height: 0,
                      transition: { duration: 0.2 }
                    }}
                    className="text-sm md:text-base text-gray-700 pb-4"
                  >
                    {faq.content}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <motion.a
            href="#"
            className="text-blue-600 hover:underline flex items-center justify-center space-x-2"
            whileHover={{ scale: 1.05 }}
          >
            <span className="text-sm md:text-base">Continua com dúvidas?</span>
            <span className="text-sm md:text-base">Veja mais respostas aqui</span>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </motion.a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;